import { gql, useLazyQuery } from '@apollo/client';

const GET_DPO_TASK_FILE_DOWNLOAD_URL = gql`
  query GetDpoTaskFileDownloadUrl($taskId: String!, $companyId: String!) {
    getDpoTaskFileDownloadUrl(taskId: $taskId, companyId: $companyId)
  }
`;

export interface GetDpoTaskFileDownloadUrlResult {
  getDpoTaskFileDownloadUrl: string;
}

export interface GetDpoTaskFileDownloadUrlInput {
  taskId: string;
  companyId: string;
}

export function useDpoTaskFileDownloadUrlQuery() {
  return useLazyQuery<GetDpoTaskFileDownloadUrlResult, GetDpoTaskFileDownloadUrlInput>(
    GET_DPO_TASK_FILE_DOWNLOAD_URL
  );
}
